<div id="cabecera">
  <div class="fixed-left">
    <jqxButton *ngIf="exportar" class="button" id="btnJqx_export" [style]="'display: flex; align-items:center'"
      [width]='25' [height]='25' (onClick)="onExportar()" [title]="translate('Exportar')">
      <i class="fa fa-file-excel fa-lg"></i>
    </jqxButton>

    <div class="arrow left-arrow" *ngIf="showLeftArrow">
      <jqxButton *ngIf="resetFiltro" [style]="'display: flex;justify-content: center;'" class="button" [width]='25'
        [height]='25' (onClick)="scrollLeft()">
        <i class="fa fa-chevron-left"></i>
      </jqxButton>
    </div>

    <div *ngIf="buscador" class="control-item">
      <div class="search-container">
        <input #searchInput class="input-t" type="text" placeholder="{{ translate('Buscar') }}..." autocorrect="off"
          autocapitalize="off" spellcheck="off" (keyup)="onBuscar()" aria-label="Buscar">
      </div>
    </div>
  </div>

  <div class="scrollable-center" #scrollable (scroll)="onScroll()">


      <div *ngIf="periodo" class="control-item">
        <span>{{ translate('Periodo') }}</span>
        <app-periodo-select #periodoSelect
          [noDia]="noDia" [noSemana]="noSemana" [noMes]="noMes" [noTrimestre]="noTrimestre"
          [noSemestre]="noSemestre" [noAnno]="noAnno" [noLibre]="noLibre" [height]="height"
          [periodoAnterior]="periodoAnterior">
        </app-periodo-select>
      </div>

      <div *ngIf="checkMetros" style="float: left; margin-left: 15px; display: flex; align-items: center;">
        <div style="display: flex;align-items: center;margin-left: 5px;">
          <jqxCheckBox #checkMasXmetros (onChange)="changeMasXmetros($event)" [theme]="theme"
            style="margin-left: 10px; float: left;" [height]="20">
          </jqxCheckBox>
          <span style="margin-left: 4px;">{{translate('Lecturas_alejadas')}}</span>
          <jqxNumberInput #masXMetrosInput [theme]="theme" [width]="90" [height]="25" [spinButtons]="true" [max]="999999999"
            [inputMode]="'simple'" [decimalDigits]="0" [style]="'margin-left: 4px'"
            [disabled]="!(checkMasXmetros?.widgetObject?.checked)" (onChange)="changeasXMetrosInput($event)">
          </jqxNumberInput>
          <span style="margin-left: 4px;">{{translate('Metros')}}</span>
        </div>
      </div>

      <div *ngIf="seeFilterMetros" style="float: left; margin-left: 15px; display: flex; align-items: center;">
        <span style="margin-left: 4px;">{{translate('Metros')}}</span>
        <jqxNumberInput #metrosInput [theme]="theme" [width]="100" [height]="25" [spinButtons]="true" [inputMode]="'simple'"
          [decimalDigits]="0" min="0" [style]="'margin-left: 4px'" (onChange)="changeMetros($event)">
        </jqxNumberInput>
      </div>

      <div *ngIf="seeCheckAlarms" style="float: left; margin-left: 15px; display: flex; align-items: center;">
        <div style="display: flex;align-items: center;margin-left: 5px;">
          <span style="margin-left: 4px;">{{translate('Alarmas_no_configuradas')}}</span>
          <jqxCheckBox #checkAlarms (onChange)="onChangeCheckAlarms($event)" [theme]="theme"
            style="margin-left: 10px; float: left;" [height]="20">
          </jqxCheckBox>
        </div>
      </div>

      <div *ngIf="seeDropModoTarj" style="float: left; margin-left: 15px; display: flex; align-items: center;">
        <div style="display: flex;align-items: center;margin-left: 5px;">
          <div style="float: left; margin-right: 5px;">{{translate('Modo')}}</div>
          <jqxDropDownList #dropModoTarjeta [source]="sourceModoTarjetas" (onBindingComplete)="onLoadModoTarjeta()"
            (onChange)="changeModoTarjeta($event)" style="float: left" [width]="110"
            [dropDownHeight]="30*sourceModoTarjetas?.length">
          </jqxDropDownList>
        </div>
      </div>

      <div *ngIf="tablalopdfilter" style="float: left; display: flex; align-items: center;">
        <span style="float:left; margin-right: 5px;margin-left: 10px;">{{translate('Tabla')}}: </span>
        <jqxDropDownList #listTabla [theme]="environment.tema" [width]="180" [height]="25"
          [searchMode]="'containsignorecase'" [filterPlaceHolder]="'Buscar...'" [displayMember]="'Nombre'"
          [filterable]="true" [source]="dataAdapterTabla" [valueMember]="'Id'" [dropDownWidth]="250" [dropDownHeight]="150"
          [checkboxes]="true" [selectionRenderer]="selectionTablaRenderer" [disabled]="false"
          (onCheckChange)="onCheckTablaLopd($event)">
        </jqxDropDownList>
      </div>

      <div *ngIf="lopdCiudadanos" style="float: left; display: flex; align-items: center;">
        <span style="float:left; margin-right: 5px;margin-left: 10px;">{{translate('Rol')}}: </span>
        <jqxDropDownList #listRoles [theme]="environment.tema" [width]="200" [height]="25"
          [searchMode]="'containsignorecase'" [filterPlaceHolder]="'Buscar...'" [displayMember]="'Nombre'"
          [filterable]="true" [source]="dataAdapteRrolesWithApp" [valueMember]="'Id'" [dropDownHeight]="150"
          [checkboxes]="true" [selectionRenderer]="selectionRolRenderer" [disabled]="false"
          (onCheckChange)="onCheckRol($event)">
        </jqxDropDownList>
      </div>

      <div *ngIf="activeAppFilter" style="float: left; display: flex; align-items: center;">
        <span style="float:left; margin-right: 5px;margin-left: 10px;">{{translate('Aplicacion')}}: </span>
        <jqxDropDownList #listApps [theme]="environment.tema" [width]="200" [height]="25"
          [searchMode]="'containsignorecase'" [filterPlaceHolder]="'Buscar...'" [displayMember]="'Nombre'"
          [filterable]="true" [source]="adapterApps" [valueMember]="'Id'" [dropDownHeight]="150" [checkboxes]="true"
          [selectionRenderer]="selectionAppRenderer" [disabled]="false" (onCheckChange)="onCheckApps($event)">
        </jqxDropDownList>
      </div>

      <div *ngIf="informesSso" style="float: left; margin-left: 15px; display: flex; align-items: center;">
        <jqxInput #searchInforme [placeHolder]="'Busqueda por Acción'" [height]='25' (onChange)="onSearchInformes()">
        </jqxInput>
      </div>

      <div *ngIf="seeCheckTarjVirtual" style="float: left; margin-left: 15px; display: flex; align-items: center;">
        <div style="display: flex;align-items: center;margin-left: 5px;">
          <div style="float: left; margin-right: 5px;">{{translate('Modo')}}</div>
          <jqxDropDownList #dropTipoTarjeta [source]="sourceTipoTarjetas" (onBindingComplete)="onLoadTipoTarjeta()"
            (onChange)="changeTipoTarjeta($event)" style="float: left" [width]="130"
            [dropDownHeight]="30*sourceTipoTarjetas.length">
          </jqxDropDownList>
        </div>
      </div>

      <div *ngIf="seeDropTipoTarj" style="float: left; margin-left: 15px; display: flex; align-items: center;">
        <div style="display: flex;align-items: center;">
          <div style="float: left;margin-right: 5px;">{{translate('Tipo')}}</div>
          <jqxDropDownList #dropTipoTarjeta [source]="sourceTipoTarjetas" (onBindingComplete)="onLoadTipoTarjeta()"
            (onChange)="changeTipoTarjeta($event)" style="float: left" [width]="150"
            [dropDownHeight]="30 * sourceTipoTarjetas?.length">
          </jqxDropDownList>
        </div>
      </div>

      <div *ngIf="seeNumVisible" style="float: left; margin-left: 15px; display: flex; align-items: center;">
        <div style="display: flex;align-items: center;margin-left: 5px;">
          <span style="margin-left: 4px;">{{translate('Num_visible')}}</span>
          <jqxCheckBox #numVisible (onChange)="onChangeNumVisible($event)" [theme]="theme"
            style="margin-left: 10px; float: left;" [height]="20" [hasThreeStates]="true">
          </jqxCheckBox>
        </div>
      </div>

      <div *ngIf="seeZonas" style="float: left; margin-left: 15px; display: flex; align-items: center;">
        <div style="float: left;align-items: center;margin-right: 5px;">{{translate('Zonas')}}</div>
        <jqxDropDownList #dropZonas [source]="sourceZonas" (onChange)="changeZona($event)" style="float: left"
          [displayMember]="'Nombre'" [valueMember]="'Nombre'" [width]="250" [filterable]="true"
          [selectionRenderer]="selectionZonesRenderer" [filterPlaceHolder]="translate('Buscar')"
          [dropDownHeight]="dropDownHeightDropZonas">
        </jqxDropDownList>
      </div>

      <div *ngIf="seeNumTarjeta" style="float: left; margin-left: 15px; display: flex; align-items: center;">
        <div style="display: flex;align-items: center;margin-left: 5px;">
          <span style="margin-left: 4px;">{{translate('Numero')}} {{translate('Tarjeta').toLowerCase()}}</span>
          <jqxNumberInput #numeroTarjeta [theme]="theme" [width]="70" [height]="25" [spinButtons]="true"
            [inputMode]="'simple'" [decimalDigits]="0" [style]="'margin-left: 4px'"
            (onChange)="onChangeNumeroTarjeta($event)">
          </jqxNumberInput>
        </div>
      </div>

      <div *ngIf="subFlota" style="float: right; display: contents">
        <span style="margin: auto;">{{translate('Subflota')}}</span>
        <div style="width: calc(100% - 80px); margin: auto;">
          <jqxDropDownList #selectSubflotas style="float:left; margin-left: 4px;" [width]="'100%'" [height]="24"
            [selectedIndex]="0" (onSelect)="onChangeSubflotas($event)" [dropDownHeight]="dropDownHeight">
          </jqxDropDownList>
        </div>
      </div>

      <div *ngIf="volumetricos" style="float: left; margin-left: 15px; display: flex; align-items: center;">
        <div style="float: left;">{{translate('Volumetricos')}}</div>
        <jqxDropDownList #cbVolumetricos style="float:left; margin-left: 4px;" [width]="230" [height]="24"
          [selectedIndex]="0">
        </jqxDropDownList>
      </div>

      <div *ngIf="listadoEstados" style="float: left; margin-left: 15px; display: flex; align-items: center;">
        <span style="float:left; margin-right: 5px">{{translate('Estado')}}</span>
        <jqxDropDownList #listEstados [theme]="environment.tema" [width]="200" [height]="25" [checkboxes]="true"
          [displayMember]="'Nombre'" [source]="adapterEstados" [valueMember]="'Id'" [autoDropDownHeight]="true"
          [disabled]="false" (onBindingComplete)="onLoadList()" (onCheckChange)="onCheckEstados($event)">
        </jqxDropDownList>
      </div>

      <div *ngIf="tipoEdificios" style="float: left; display: flex; align-items: center;">
        <span style="float:left; margin-right: 5px;margin-left: 10px;">{{translate('Tipo_edificio')}}: </span>
        <jqxDropDownList #selectTipoEdificios [theme]="environment.tema" [width]="200" [height]="25"
          [searchMode]="'containsignorecase'" [filterPlaceHolder]="'Buscar...'" [displayMember]="'Nombre'"
          [filterable]="true" [source]="dataAdapterTipoEdificios" [valueMember]="'Id'" [dropDownHeight]="150"
          [checkboxes]="true" [selectionRenderer]="selectionTipoEdificioRenderer" [disabled]="false"
          (onCheckChange)="checkselectTipoEdificios($event)">
        </jqxDropDownList>
      </div>
    </div>



  <div class="fixed-right">

    <div class="arrow right-arrow" *ngIf="showRightArrow">
      <jqxButton *ngIf="resetFiltro" [style]="'display: flex;justify-content: center;'" class="button" [width]='25'
        [height]='25' (onClick)="scrollRight()">
        <i class="fa fa-chevron-right"></i>
      </jqxButton>
    </div>

    <div *ngIf="buscadorAPI" style="float: left; margin-left: 15px; display: flex; align-items: center;">
      <div [ngClass]="filterApiError ? 'inputError' : 'input'">
        <input #searchInputApi type="text" style="border: 0; width: 100%; outline: none;"
          placeholder="{{ translate('Buscar') }}..." autocorrect="off" autocapitalize="off" spellcheck="off">
      </div>
    </div>

    <jqxButton *ngIf="filtro" class="button"
      style="float:left; cursor: pointer; justify-content: center; align-items: center; display: flex;"
      [width]='25' [height]='25' [title]="translate('Filtrar')" (onClick)="onFilter()">
      <img src="/assets/images/filter.png" style="height: 20px; width: 20px;">
    </jqxButton>

    <jqxButton *ngIf="resetFiltro" class="button"
    style="float:left; margin-left: 5px; cursor: pointer; justify-content: center; align-items: center; display: flex;"
    [width]='25' [height]='25' [title]="translate('Restablecer_filtros')" (onClick)="onResetFilter()">
    <img src="/assets/images/filter_cancel.png" style="height: 20px; width: 20px;">
  </jqxButton>
  </div>
</div>
